var $9af183cfb2cb9094$exports = {};
$9af183cfb2cb9094$exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};


export {$9af183cfb2cb9094$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
